import { appendOrderItems, removeOrderItemById } from './slices/orderSlice';
import { appendOpenOrderItems, removeOpenOrderItemById } from './slices/productsSlice';
import { store } from './store';

const PENDING_PREFIX = 'pending-';
let sequence = 0;

export const isPendingId = (id) => typeof id === 'string' && id.startsWith(PENDING_PREFIX);

export const PENDING_ITEMS_MESSAGE = 'Some items are still being saved. Please wait a moment and try again.';

export const hasPendingItem = (items) => Array.isArray(items) && items.some((item) => isPendingId(item?.id));

export const buildOrderItem = (product, id, quantity) => ({
    ...product,
    id,
    product_netsuite_id: product?.netsuite_id ?? product?.product_netsuite_id,
    product_name: product?.name,
    product_code: product?.code,
    vat: product?.taxable?.toLowerCase() === 'taxable' ? 20 : 0,
    quantity: quantity ?? 1,
});

// Shows the item in the order straight away; it is replaced by the saved item or taken out again if saving fails.
export const startPendingItem = (body, product) => {
    const id = `${PENDING_PREFIX}${++sequence}`;
    const item = { ...buildOrderItem(product, id, body?.quantity), order_id: body?.order_id ?? null };
    store.dispatch(appendOrderItems(item));
    store.dispatch(appendOpenOrderItems(item));
    return id;
};

// Items still being saved that belong to this order and are not in the list the server just returned.
export const pendingItemsFor = (orderId, savedItems = []) =>
    (store.getState().orderSlice.orderItems || []).filter(
        (item) =>
            isPendingId(item?.id) &&
            (!item.order_id || String(item.order_id) === String(orderId)) &&
            !savedItems.some((saved) => saved.product_netsuite_id === item.product_netsuite_id)
    );

export const discardPendingItem = (id) => {
    store.dispatch(removeOrderItemById(id));
    store.dispatch(removeOpenOrderItemById(id));
};
